import { Component, OnInit } from '@angular/core';
import { Output, EventEmitter, Input } from '@angular/core';
import { SearchCamAndProbComponentMiramas } from '../search-cam-and-prob/search-cam-and-prob.component';

@Component({
  selector: 'app-search-ticket-miramas',
  templateUrl: './search-ticket.component.html',
  styleUrls: ['./search-ticket.component.scss']
})


export class SearchTicketComponentMiramas {
 camera:string = "";
 probleme:string = "";

@Output() newItemEventCamera = new EventEmitter<string>();
@Output() newItemEventProblem = new EventEmitter<string>();
@Output() newItemEventInput = new EventEmitter<string>();
@Output() newAnnulerTout = new EventEmitter<string>();
@Output() newCreateTicketEvent = new EventEmitter<string>();
@Input() poste = "";

 addCamera(newItem: string) {
    this.camera = newItem;
    this.newItemEventCamera.emit(newItem);
  }
  addProbleme(newItem: string) {
     this.probleme = newItem;
     this.newItemEventProblem.emit(newItem);

   }

  getOpenInput(newItem: string) {
     this.newItemEventInput.emit(newItem);

   }
  getAnnulerTout(newItem: string) {
     this.newAnnulerTout.emit(newItem);

   }
getCreateTicket(newEvent: string) {
     this.newCreateTicketEvent.emit(newEvent);

   }


  constructor(private camProb:SearchCamAndProbComponentMiramas) { }


}
